module.exports = __webpack_public_path__ + "static/short-cloud-9ab927bb31b4830ddb5312e1295a156c.png";